import "./sliderAwards.scss";

import "swiper/css/bundle";

import Swiper from "swiper/bundle";

const sliderAwards = () => {
  let allsliderAwards = document.querySelectorAll(".slider-awards");

  if (!allsliderAwards.length) return;

  allsliderAwards.forEach((el, i) => {
    let pagination = el.querySelector(".swiper-pagination");
    let typePagination = "bullets";

    let args = {
      slidesPerView: 1,
      breakpoints: {
        0: {
          slidesPerView: 1,
          loop: true,
        },
        768: {
          slidesPerView: 4,
          loop: false,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 40,
          loop: false,
        },
      },
      spaceBetween: 20,
      //   centeredSlides: true,
      //   roundLengths: true,
      pagination: {
        el: pagination,
        clickable: true,
        type: typePagination,
      },
      //   navigation: {
      //     nextEl: ".slider-cards__next",
      //     prevEl: ".slider-cards__prev",
      //   },
      a11y: {
        enabled: true,
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
        firstSlideMessage: "This is the first slide",
        lastSlideMessage: "This is the last slide",
        paginationBulletMessage: "Go to slide {{index}}",
        notificationClass: "swiper-notification",
      },
    };

    new Swiper(el.querySelector(".swiper-container"), args);
  });
};

export default sliderAwards;
